/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from "react";
import { MdGrain, MdOutlinePeopleAlt } from "react-icons/md";
import { FaRegStar } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { useGetDestaques } from "services/api/Destaques/get-destaques";
import { useGetDestaquesDetalhes } from "services/api/Destaques/get-destaques-detalhe";
import CustomPagination from "components/CustomPagination";

import { CiCalendar } from "react-icons/ci";
import InputRanking from "screens/leads/components/SearchRankingInput";
import * as S from "./styles";
import NavCommon from "../../components/@navHeader";
import MaterialUI from "../../material-UI";

// Tipos
type Ranking = {
  posicao: number;
  equipe: string;
  apelido: string;
  pontuacao: number;
  urlFoto: string | null;
};

type Regional = {
  idRanking: string;
  codigoCargo: number;
  titulo: string;
  numeroMembros: number;
  tipoVisualizacao: string;
  urlFotoBandeira: string;
  dataAtualizacao: string;
  corDestaque: string;
  usuarios: Ranking[];
};

function Destaques() {
  const history = useHistory();

  // --------------------------------------------------
  // Estados
  // --------------------------------------------------
  // Guarda o título e o idRanking/cargo ao clicar no card
  const [selectedTitle, setSelectedTitle] = useState<string>("");
  const [selectedRegion, setSelectedRegion] = useState<string>(""); // ID do ranking
  const [selectedCargo, setSelectedCargo] = useState<string>(""); // ou number, se preferir

  const [searchTerm, setSearchTerm] = useState("");

  // Paginação
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(10);

  // --------------------------------------------------
  // 1) Chamada de API para o Top 3 (cards iniciais)
  // --------------------------------------------------
  const { data: dataDestaques, isLoading } = useGetDestaques({
    quantidadeUsuariosPorDestaque: 3,
    queryKey: "destaques-3",
  });

  // --------------------------------------------------
  // 2) Chamada de API para detalhes
  //
  // Pelo seu JSON final, sabemos que a resposta vem em:
  // {
  //   "success": true,
  //   "data": {
  //     "destaque": { ... }
  //   },
  //   "pagination": { ... }
  // }
  // --------------------------------------------------
  const {
    data: dataAll,
    isFetching: isFetchingDetalhes,
    refetch,
  } = useGetDestaquesDetalhes({
    PaginaAtual: currentPage,
    TotalItensRetorno: itemsPerPage,
    PalavraChave: searchTerm,
    CodigoCargo: selectedCargo,
    IdRanking: selectedRegion, // Envia o ID da regional selecionada
    queryKey: `destaques-detalhes${selectedRegion}${selectedCargo}`,
  });

  // --------------------------------------------------
  // Efeito para chamar o refetch quando trocarmos
  // de region, cargo ou página
  // --------------------------------------------------
  useEffect(() => {
    if (selectedRegion) {
      refetch();
    }
  }, [selectedRegion, selectedCargo, currentPage, itemsPerPage, refetch]);

  // --------------------------------------------------
  // Agora, em vez de "find", pegamos diretamente o objeto
  // que vem em dataAll?.data?.destaque
  // --------------------------------------------------
  const selectedRegionalData: Regional | undefined = dataAll?.data?.destaque;

  // --------------------------------------------------
  // Para a paginação, usamos os dados retornados em dataAll.pagination
  // Exemplo: quantityPages
  // --------------------------------------------------
  const totalPages = dataAll?.pagination?.quantityPages || 1;

  // --------------------------------------------------
  // Handler de mudança de página
  // --------------------------------------------------
  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    setCurrentPage(page);
  };

  const handleSearchEnter = async (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key === "Enter") {
      await setCurrentPage(1);
      refetch();
    }
  };

  // --------------------------------------------------
  // Render
  // --------------------------------------------------
  return (
    <>
      <NavCommon
        breadcrumbs={[{ path: "/destaques", name: "Destaques" }]}
        onBack={() => history.goBack()}
        onChangeActionNew={() => history.push("/")}
      />

      <S.Content>
        <S.Container>
          {/* Header */}
          <S.Header>
            <S.HeaderTitle>Destaques</S.HeaderTitle>
            <FaRegStar color="#1A49CC" size={24} />
          </S.Header>

          {/* Grid com os cards das regionais (Top 3) */}
          {isLoading ? (
            <div
              style={{
                display: "flex",
                marginTop: "16px",
                justifyContent: "center",
              }}
            >
              <MaterialUI.CircularProgress
                style={{ color: "blue" }}
                size={36}
              />
            </div>
          ) : (
            <S.RegionalsGrid>
              {dataDestaques?.destaques?.map((regional: Regional) => {
                const isActive = selectedTitle === regional.titulo;

                return (
                  <S.RegionalCard key={regional.idRanking} isActive={isActive}>
                    {/* Cabeçalho com gradiente dinâmico */}
                    <S.RegionalCardHeader>
                      <S.RegionalIcon>
                        <S.RegionalBandeiraImg
                          src={regional.urlFotoBandeira}
                          alt="bandeira"
                        />
                      </S.RegionalIcon>
                      <S.RegionalInfos>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <CiCalendar color="#646363" />
                          <S.RegionalTextInfo>
                            Atualizado em {regional.dataAtualizacao}
                          </S.RegionalTextInfo>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <MdGrain color="#646363" />
                          <S.RegionalTextInfo>
                            {regional.tipoVisualizacao}
                          </S.RegionalTextInfo>
                        </div>
                      </S.RegionalInfos>
                    </S.RegionalCardHeader>

                    {/* Linha divisoria */}
                    <S.RegionalLine corDestaque={regional.corDestaque} />
                    {/* Top 3 usuários */}
                    <S.RegionalCardBody>
                      {regional.usuarios.slice(0, 3).map((rank) => (
                        <S.Top3Item key={rank.posicao}>
                          <S.Avatar
                            src={rank.urlFoto ?? ""}
                            alt={rank.equipe}
                          />
                          <S.RankInfo>
                            <p>{rank.apelido}</p>
                            <span>{rank.equipe}</span>
                          </S.RankInfo>
                          <S.PointsInfo>{rank.pontuacao}</S.PointsInfo>
                        </S.Top3Item>
                      ))}
                      <div
                        style={{
                          // Exibe o botão "Ver mais" quando houver mais de 3 usuários
                          display:
                            regional.usuarios.length >= 3 ? "block" : "none",
                          width: "100%",
                          height: "100%",

                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <S.ButtonSeeMore
                          onClick={() => {
                            // Ao clicar no card, salva o título e o cargo
                            // e também o ID da regional
                            setCurrentPage(1);
                            setSelectedTitle(regional.titulo);
                            setSelectedRegion(regional.idRanking);
                            setSelectedCargo(String(regional.codigoCargo));
                          }}
                        >
                          Ver mais
                        </S.ButtonSeeMore>
                      </div>
                    </S.RegionalCardBody>
                  </S.RegionalCard>
                );
              })}
            </S.RegionalsGrid>
          )}

          {/* Ranking detalhado da Regional selecionada */}
          {selectedRegionalData ? (
            <S.DetailedRanking>
              {/* Cabeçalho do ranking detalhado */}
              <S.DetailedRankingHeader color="#F5F5F5">
                <S.RegionalIcon>
                  <S.RegionalBandeiraImg
                    src={selectedRegionalData?.urlFotoBandeira}
                    alt="bandeira"
                  />
                </S.RegionalIcon>
                <S.Filters>
                  <InputRanking
                    handleBtnSearch={() => {}}
                    onChange={(e: any) => setSearchTerm(e.target.value)}
                    onKeyDown={handleSearchEnter}
                    variant="outlined"
                    placeholder="Buscar Usuários"
                  />
                </S.Filters>
              </S.DetailedRankingHeader>
              {/* Linha divisoria */}
              <S.RegionalLine corDestaque={selectedRegionalData.corDestaque} />
              {/* Lista detalhada de todos os usuários da regional */}
              <S.DetailedRankingList>
                {selectedRegionalData?.usuarios.map((rank, index) => (
                  <S.DetailedRankingItem key={index}>
                    <S.AvatarBig src={rank.urlFoto ?? ""} alt={rank.apelido} />
                    <div>
                      <h3>{rank.apelido}</h3>
                      <span>{rank.equipe}</span>
                    </div>
                    <S.PointsGradient>{rank.pontuacao}</S.PointsGradient>
                  </S.DetailedRankingItem>
                ))}
              </S.DetailedRankingList>
              {/* Paginação */}
              <S.ContainerFooter>
                <CustomPagination
                  count={totalPages} // total de páginas
                  page={currentPage} // página atual
                  onPageChange={handlePageChange}
                />
              </S.ContainerFooter>
            </S.DetailedRanking>
          ) : isFetchingDetalhes ? (
            <div
              style={{
                display: "flex",
                marginTop: "16px",
                justifyContent: "center",
              }}
            >
              <MaterialUI.CircularProgress
                style={{ color: "blue" }}
                size={22}
              />
            </div>
          ) : null}
        </S.Container>
      </S.Content>
    </>
  );
}

export default Destaques;
